import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AurCurrencyPipe } from '@arc/aureus';
import { TranslateModule } from '@ngx-translate/core';
import { ArcSharedModule } from '@arc/arc-shared-frontend';
import { TranslateStoreModule } from './store/translate.store.module';
import { InternationalCurrencyPipe } from './pipes/international-currency.pipe';
import { PaymentsEngineDatePipe } from './pipes/payments-engine-date.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { LanguageDropdownComponent } from './components/language-dropdown/language-dropdown.component';
import { LanguageDropdownContainerComponent } from './components/language-dropdown/language-dropdown-container.component';

@NgModule({
  declarations: [
    InternationalCurrencyPipe,
    PaymentsEngineDatePipe,
    LocalDatePipe,
    LanguageDropdownComponent,
    LanguageDropdownContainerComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TranslateStoreModule,
    ArcSharedModule,
  ],
  exports: [
    TranslateModule,
    InternationalCurrencyPipe,
    PaymentsEngineDatePipe,
    LocalDatePipe,
    TranslateStoreModule,
    LanguageDropdownContainerComponent,
  ],
  providers: [AurCurrencyPipe, PaymentsEngineDatePipe, LocalDatePipe],
})
export class I18nModule {}
